/**
 * A pay-app line's retainage held NOW, after every release to date -- as ComputerEase's G702 line 5 and continuation
 * sheet show it (2026-11-02). retainage_amount is the cumulative held before releases; a line from before then has no
 * running total of its releases, so its own release stands in. The server's twin is heldNowSql in server/retainage.js.
 */
const num = (v) => parseFloat(v) || 0;

export const heldNow = (l) => Math.max(0, num(l.retainage_amount)
  - num(l.retainage_released_to_date != null ? l.retainage_released_to_date : l.retainage_released_this_period));

/**
 * A line's typed retainage %, or null when it isn't a number from 0 to 100. Blank isn't one (Duncan 2026-11-03: "Blank
 * should not be an option" -- the "+ Line" box started at 0, so a skipped box saved a 0% line). The server's twin is
 * retainagePercentOf in server/retainage.js.
 */
export const retainagePercentOf = (v) => {
  if (v === null || v === undefined || String(v).trim() === '') return null;
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 && n <= 100 ? n : null;
};
export const RETAINAGE_PERCENT_REQUIRED = 'Enter a retainage % from 0 to 100 for this line.';
